import $                   from 'jquery';
import pageSyncService     from 'PageSyncService';
import pageInstanceFactory from 'PageInstanceFactory';
import eventBus            from 'EventBus';
import undoService         from 'UndoService';
import listService         from 'ListService';
import constants           from 'Constants';
import textConstants       from 'TextConstants';
import CloseFormConfirmationModalView   from 'common-views/CloseFormConfirmationModalView';
import formSaveService     from 'FormSaveService';
import {Model} from 'backbone';
import notificationService  from 'NotificationService';

const canvases = '#aPage, #aPageSel';

class FormService{

    //==========================================================================================
    // Create a page, reopen the layout with it as the
    // current page.
    //
    // Note: by "page", we mean an instance of PageInstanceView, not its single PageView parent.
    // The latter holds the canvases, dropshadow, and properties. The PageInstanceView is
    // related N:1 to the PageView. A PageView's model holds it's page ID. Each control of that
    // page holds that ID in it's model.
    //==========================================================================================
    addPage( ) {

        // Ensure we have canvases. They're hidden if user had deleted last page instance.
        $(canvases).show();

        // 1. Clear visible controls from the dom
        pageSyncService.clearCurrentPageView();

        // 2. Create new page in backing list, making it the current page.
        const myPage = pageInstanceFactory.createView( 'page_instance' , 'addPage' );

        eventBus.trigger('pageRedraw', myPage.model.get('backgroundColor'),
            myPage.model.get('backgroundImageAssetId'),  myPage.model.get('backgroundImageStyle'));

        // 3. Visually show selection on the thumbnail for the page
        pageSyncService.selectThumbNail( );

        // 4. Scroll thumbnails to new entry.
        $( constants.THUMBPANE_ID ).scrollTop( Number.MAX_VALUE );

        undoService.add({
            undo: ()=>{
                listService.deletePage(myPage.id);
                // 3. Visually show selection on the thumbnail for the page
                // PF-2223: Selecting last active page
                const pages = [...listService.pageList];
                if (pages.length) {
                    let lastPageId = pages[pages.length-1][0];
                    pageSyncService.selectThumbNail(true, lastPageId);
                }

                // 4. Scroll thumbnails to new entry.
                $( constants.THUMBPANE_ID ).scrollTop( Number.MAX_VALUE );
            },
            redo: ()=>{
                listService.addPage(myPage.id, myPage)
                // 3. Visually show selection on the thumbnail for the page
                pageSyncService.selectThumbNail( );

                // 4. Scroll thumbnails to new entry.
                $( constants.THUMBPANE_ID ).scrollTop( Number.MAX_VALUE );

                // 5. (PF-2223) Force click, so page is selected
                $('.tn-target').click();

            }
        }, textConstants.UNDO_NEW_PAGE)
    }

    async confirmSaveOnClose() {
      
        if (listService.isSaveDialogOpened || !undoService.hasChanges()) {
            return;
        }
    
        listService.isSaveDialogOpened = true;
    
        try {
            const docType = listService.docType === constants.DOC_TYPE_REPORT ? 'report' : 'app';
            const confirmationText = `Would you like to save the changes you made to this ${docType}?`;
    
            const closeFormConfirmationModalView = new CloseFormConfirmationModalView({
                model: new Model({ confirmationText, height: 140, width: 500 })
            });
    
            const result = await closeFormConfirmationModalView.render();
    
            listService.linkClicked = true;
    
            if (result === 'Yes') {
                const closeAction = () => {
                    setTimeout(() => { Backbone.history.loadUrl('close'); }, 250); //Wait for save                    
                };                
                
                formSaveService.handleSave({ saveType: 'save', onClose: closeAction });
            } else if (result === 'No') {
                Backbone.history.loadUrl('close');
            }
        } catch (err) {
            console.log('Error Showing Save App Confirmation Modal', err);
            notificationService.error(`Error Showing Save App Confirmation Modal: ${err.message || err}`);
        } finally {
            listService.isSaveDialogOpened = false;
        }
    }

}

export default new FormService;